export default __webpack_public_path__ + "static/reports-290d71c04718fa9c81df506fd019480b.png";